import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

import { StatusActions } from "./instructions/hook";

function FormConsentLabelPreview({ ...props }) {
  const { field: { field_component } } = useFormFieldContext()
  const actions = field_component === 'checkbox_instructions_text' ? <StatusActions /> : null

  return <BasePreview {...props} customActions={actions}>
    <span>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.
    </span>
  </BasePreview>
}

export default define('form-consent-label', FormConsentLabelPreview, Fragment)
  .shared(prop.share('FormConsentLabel', 'form-consent-label'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    fontSize: 'sm',
  })
  .build()

